/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_EyebrowInputs */

const tr_kullanim_eyebrow = /** @type {(inputs: Kullanim_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kullanım Koşulları`)
};

const en_kullanim_eyebrow = /** @type {(inputs: Kullanim_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of Use`)
};

const de_kullanim_eyebrow = /** @type {(inputs: Kullanim_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzungsbedingungen`)
};

const ru_kullanim_eyebrow = /** @type {(inputs: Kullanim_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Условия использования`)
};

/**
* | output |
* | --- |
* | "Terms of Use" |
*
* @param {Kullanim_EyebrowInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_eyebrow = /** @type {((inputs?: Kullanim_EyebrowInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_EyebrowInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_eyebrow(inputs)
	if (locale === "de") return de_kullanim_eyebrow(inputs)
	if (locale === "ru") return ru_kullanim_eyebrow(inputs)
	return tr_kullanim_eyebrow(inputs)
});